import { Injectable } from '@angular/core';
import {
  AddRewardToPartnerRequest,
  AttemptRewardClaimRequest,
  GetRewardRequest,
  IsRewardConditionMetForPartnerRequest,
  RewardInterface,
  RewardsApiService,
} from '@vendasta/partner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RewardsService {
  constructor(private api: RewardsApiService) {}

  addRewardToPartner(partnerId: string, rewardId: string): Observable<boolean> {
    const req = new AddRewardToPartnerRequest({ partnerId: partnerId, rewardId: rewardId });
    return this.api.addRewardToPartner(req).pipe(map((resp) => resp.ok));
  }

  attemptRewardClaim(partnerId: string, rewardId: string): Observable<boolean> {
    const req = new AttemptRewardClaimRequest({ partnerId: partnerId, rewardId: rewardId });
    return this.api.attemptRewardClaim(req).pipe(map((resp) => resp.ok));
  }

  getReward(partnerId: string, rewardId: string): Observable<RewardInterface> {
    const req = new GetRewardRequest({ partnerId: partnerId, rewardId: rewardId });
    return this.api.getReward(req).pipe(map((resp) => resp.reward));
  }

  isRewardConditionMetForPartner(partnerId: string, rewardId: string): Observable<boolean> {
    const req = new IsRewardConditionMetForPartnerRequest({ partnerId: partnerId, rewardId: rewardId });
    return this.api.isRewardConditionMetForPartner(req).pipe(map((resp) => resp.rewardConditionsMet));
  }
}
